// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import advancingCareContainerView  from '../../../../templates/MIPS/Dashboard/advancingCareContainerView';

// Internal Dependencies - models/collections

export default Marionette.ItemView.extend({

    initialize: function() {
        this.channel = Backbone.Radio.channel( 'AppChannel' );
        this.app = this.channel.request( 'app' );
        this.listenTo( this.model, 'change:dashboardData', this.render );
    },

    getTemplate: function() {
        return advancingCareContainerView( this.model );
    },

});
